import React from 'react';
import PropTypes from 'prop-types';
import './NotificationItem.less';
import moment from 'moment';
import { REACT_APP_IMG } from 'cfgCommon/config';
import { useHistory } from 'react-router-dom'
import Tooltip from '@material-ui/core/Tooltip';

export const formatTimeAgo = (timestamp) => {
  const now = moment();
  const duration = moment.duration(now.diff(moment(timestamp)));
  const seconds = duration.asSeconds();
  const minutes = duration.asMinutes();
  const hours = duration.asHours();

  if (seconds < 120) { // Menos de 2 minutos
    return `Hace 1 minuto`;
  } else if (minutes < 60) { // Menos de 1 hora
    return `Hace ${Math.floor(minutes)} minuto${Math.floor(minutes) !== 1 ? 's' : ''}`;
  } else if (hours < 24) { // Menos de 24 horas
    return `Hace ${Math.floor(hours)} hora${Math.floor(hours) !== 1 ? 's' : ''}`;
  } else if (hours < 48) { // Entre 24 y 48 horas
    return `Ayer`;
  } else { // Más de 48 horas
    return moment(timestamp).format('D [de] MMMM'); // Formato: "15 de julio"
  }
};

const NotificationItem = ({ notification, onMarkAsRead, onMarkAsUnread, closeMenu }) => {
  const history = useHistory()
  const handleClick = () => {
    if (notification.redirectUrl) {
      history.push(notification.redirectUrl)
      closeMenu()
    }
    if (!notification.read) {
      onMarkAsRead(notification.id)
    }
  }

  const notificationTitleClasses = `notificationTitle ${!notification.read ? 'notificationTitleUnread' : ''}`
  const notificationItemClasses = `notificationItem ${!notification.read ? 'notificationItemUnread' : ''}`
  const formatNotificationImage = () => {
    let imageUrl
    try {
      imageUrl = new URL(notification?.icon)
    } catch (error) {
      imageUrl = `${REACT_APP_IMG}/${notification.icon}`
    }
    return imageUrl
  }

  const handleBadgeClick = (e) => {
    e.stopPropagation();
    if (notification.read) {
      onMarkAsUnread(notification.id);
    } else {
      onMarkAsRead(notification.id);
    }
  }
  
  return (
    <div className={notificationItemClasses} onClick={handleClick}>
      <div className="notificationBadgeContainer">
        <Tooltip title={notification.read ? 'Marcar como no leída' : 'Marcar como leída'} arrow>
          <div onClick={handleBadgeClick} className={`notificationBadgeContainerInnerCircle ${notification.read ? 'read' : 'unread'}`}
          >
            <span className={`notificationBadge ${notification.read ? 'read' : 'unread'}`}></span>
          </div>
        </Tooltip>
      </div>
      <div className="notificationIcon">
        {notification.icon && (
          <img src={formatNotificationImage()} alt="Icono de notificación" className="notificationMiniIcon" />
        )}
      </div>
      <div className='notificationContent'>
        <div>
          <span className={notificationTitleClasses}>{notification.title}</span>
          {notification.message}
        </div>
        <div className="notificationTime">{formatTimeAgo(notification.time)}</div>
      </div>
    </div>
  );
};

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    redirect_url: PropTypes.string,
  }).isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
  onMarkAsUnread: PropTypes.func.isRequired,
  closeMenu: PropTypes.func.isRequired,
};

export default NotificationItem;
